import type { TaskTimelineItem } from '~/types'

import TimelineCard, { type TimelineCardProps } from '../TimelineCard'
import { useTaskCardProps } from './hooks/useTaskCardProps'
import { TaskCardContent } from './TaskCardContent'

export interface TaskCardProps extends TimelineCardProps {
  clientId: string
  item: TaskTimelineItem
  patientId: string
}

const TaskCard = ({ item, clientId, patientId, ...rest }: TaskCardProps) => {
  const taskCardProps = useTaskCardProps(item, clientId, patientId)

  return (
    <TimelineCard {...item} {...taskCardProps} {...rest}>
      <TaskCardContent clientId={clientId} item={item} patientId={patientId} />
    </TimelineCard>
  )
}

export default TaskCard
